export default __webpack_public_path__ + "images/2297c22cbcc4efd906ee4190951c1194-fundraising.jpg";